import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-helpbutton-reports-assistance-voice-card',
  templateUrl: './helpbutton-reports-assistance-voice-card.component.html',
  styleUrls: ['./helpbutton-reports-assistance-voice-card.component.scss']
})
export class HelpbuttonReportsAssistanceVoiceCardComponent implements OnInit {

  @Input() value;

  constructor() { }

  ngOnInit() {
  }

}
